(function () {
  'use strict';

  class CiariProductShowcase extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.track = this.querySelector('.cshow__track');
      this.onSwatchClick = this.onSwatchClick.bind(this);
      this.addEventListener('click', this.onSwatchClick);
      this.slides = Array.from(this.querySelectorAll('.cshow__slide'));
      this.prev = this.querySelector('.cshow__nav--prev');
      this.next = this.querySelector('.cshow__nav--next');
      this.index = window.matchMedia('(max-width: 599px)').matches ? Math.min(1, this.slides.length - 1) : 0;

      if (!this.track || this.slides.length < 2) {
        this.dataset.static = '';
        return;
      }

      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.prev.addEventListener('click', () => this.step(-1), { signal });
      this.next.addEventListener('click', () => this.step(1), { signal });
      this.track.addEventListener('keydown', (event) => this.onKeyDown(event), { signal });
      this.track.addEventListener('scroll', () => this.queueSync(), { passive: true, signal });
      window.addEventListener('resize', () => this.queueSync(), { passive: true, signal });
      this.cleanupDrag = window.CiariCarousel.initializeHorizontalDragScroll(this.track, {
        onDragEnd: () => {
          window.requestAnimationFrame(() => window.requestAnimationFrame(() => this.goTo(this.index, true)));
        }
      });
      window.requestAnimationFrame(() => this.goTo(this.index, false));
    }
onSwatchClick(event) {
  const swatch = event.target.closest('.cshow__swatch');
  if (!swatch || !this.contains(swatch)) return;

  event.preventDefault();

  const slide = swatch.closest('.cshow__slide');
  if (!slide) return;

  const swatches = Array.from(slide.querySelectorAll('.cshow__swatch'));

  swatches.forEach((item) => {
    item.classList.toggle('is-selected', item === swatch);
  });

  const productLink = swatch.getAttribute('href');
  const productUrl = productLink ? new URL(productLink, window.location.origin) : null;

  if (!productUrl) return;

  const variantId = productUrl.searchParams.get('variant');

  if (!variantId) {
    console.warn('No variant ID found for this swatch.');
    return;
  }

  const image = slide.querySelector('.cshow__image');
  if (!image) return;

  fetch(productUrl.pathname + '.js')
    .then((response) => {
      if (!response.ok) throw new Error('Unable to load product data');
      return response.json();
    })
    .then((product) => {
      const variant = product.variants.find(
        (item) => String(item.id) === String(variantId)
      );

      if (!variant || !variant.featured_image) {
        console.warn('No featured image found for this variant.');
        return;
      }

      image.src = variant.featured_image.src;
      image.srcset = '';
    })
    .catch((error) => {
      console.error('Swatch image update failed:', error);
    });
}
    step(direction) {
      const limit = this.maxIndex;
      this.goTo((this.index + direction + limit + 1) % (limit + 1), true);
    }

    goTo(index, animate) {
      index = Math.min(Math.max(index, 0), this.maxIndex);
      const slide = this.slides[index];
      if (!slide) return;
      this.index = index;
      const left = slide.offsetLeft - this.slides[0].offsetLeft;
      this.track.scrollTo({ left, behavior: animate && !this.reducedMotion ? 'smooth' : 'auto' });
      this.syncState();
    }

    queueSync() {
      if (this.frame) return;
      this.frame = window.requestAnimationFrame(() => {
        this.frame = null;
        const center = this.track.scrollLeft + (this.track.clientWidth / 2);
        let nearest = 0;
        let distance = Infinity;
        const origin = this.slides[0].offsetLeft;
        this.slides.forEach((slide, index) => {
          const nextDistance = Math.abs((slide.offsetLeft - origin + slide.offsetWidth / 2) - center);
          if (nextDistance < distance) {
            distance = nextDistance;
            nearest = index;
          }
        });
        this.index = Math.min(nearest, this.maxIndex);
        this.syncState();
      });
    }

    syncState() {
      const staticTrack = this.maxIndex === 0;
      this.prev.hidden = staticTrack;
      this.next.hidden = staticTrack;
      this.slides.forEach((slide, index) => slide.toggleAttribute('data-active', index === this.index));
    }

    get maxIndex() {
      const first = this.slides[0];
      if (!first || !this.track.clientWidth) return 0;
      const styles = window.getComputedStyle(this.querySelector('.cshow__slides'));
      const gap = parseFloat(styles.columnGap || styles.gap) || 0;
      const visible = Math.max(1, Math.round((this.track.clientWidth + gap) / (first.offsetWidth + gap)));
      return Math.max(0, this.slides.length - visible);
    }

    onKeyDown(event) {
      if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
      event.preventDefault();
      this.step(event.key === 'ArrowRight' ? 1 : -1);
    }

    get reducedMotion() {
      return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }

    disconnectedCallback() {
      this.initialized = false;
      if (this.controller) this.controller.abort();
      if (this.cleanupDrag) this.cleanupDrag();
      if (this.frame) window.cancelAnimationFrame(this.frame);
    }
  }

  if (!customElements.get('ciari-product-showcase')) {
    customElements.define('ciari-product-showcase', CiariProductShowcase);
  }
})();
